<template>
	<div>
		<div class="calendar-content">
			<a href="javascript:void(0)" @click="openCalendar()">
				<p class="date">{{ showDate }}</p>
				<p class="calendar color-pass">
					<svg><use :xlink:href="svg.calendar" :href="svg.calendar"></use></svg>
					<span>{{ trad.modify }}</span>
				</p>
			</a>
			<datepicker :format="customFormatter" :language="lang" :monday-first="true" ref="restoDetailCalendar" input-class="calendar-picker" calendar-class="calendar-opened" :value="selectedDate" :disabled="disabledDate" :highlighted="highlightedDate" :bootstrap-styling="true" :minimumView="'day'" :maximumView="'day'">
			</datepicker>
		</div>
		<hr />
		<div class="promo">
			<div class="row" :class="[isPromo ? '' : 'd-none']">
				<div class="col-6">
					<div class="inner bg-pass">
						<p class="percent">-{{ promonoon }}</p>
						<p>{{ trad.noon }}</p>
					</div>
				</div>
				<div class="col-6">
					<div class="inner bg-pass">
						<p class="percent">-{{ promoeve }}</p>
						<p>{{ trad.eve }}</p>
					</div>
				</div>
			</div>
			<div class="row" :class="[isPromo ? 'd-none' : '']">
				<div class="col-12 no-promo">
					<h3>{{ trad.nopromo }}</h3>
				</div>
			</div>
		</div>
		<hr />

		<div class="more center color-pass" v-if="isDiscovery">
			<div>
				<svg viewBox="0 0 30 31"><use :xlink:href="svg.discovery" :href="svg.discovery"></use></svg>
			</div>
			<div>
				<p class="mb-2" v-html="trad.discovery"></p>
				<div class="promo discovery">
					<div class="row">
						<div class="col-6">
							<div class="inner discovery">
								<p class="percent">-{{ discoverynoon }}</p>
								<p>{{ trad.noon }}</p>
							</div>
						</div>
						<div class="col-6">
							<div class="inner discovery">
								<p class="percent">-{{ discoveryeve }}</p>
								<p>{{ trad.eve }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Datepicker from 'vuejs-datepicker'
	import moment from 'moment'

	export default {

		props: ['trad','lang','svg','promo','discovery','close'],

		components: {
			Datepicker
		},

		data () {
			return {
				selectedDate: moment().locale(this.lang).format('dddd DD MMMM YY'),
				showDate: moment().locale(this.lang).format('dddd D MMMM'),
				date: new Date(),
				disabledDate: {},
				highlightedDate: {},
				isPromo: '',
				isDiscovery: false,
				promonoon: '',
				promoeve: '',
				discoverynoon: '',
				discoveryeve: '',
				weekdays: {
					0: 'sunday',
					1: 'monday',
					2: 'tuesday',
					3: 'wednesday',
					4: 'thursday',
					5: 'friday',
					6: 'saturday',
				}
			}
		},

		mounted() {
			const promo		= this.promo
			const discovery	= this.discovery
			const close		= this.close
			const weekdays	= this.weekdays

			this.disabledDate = {
				to: new Date((this.date.getFullYear()-1), this.date.getMonth(), this.date.getDate()), // Disable all dates up 1 year
				from: new Date((this.date.getFullYear()+1), this.date.getMonth(), this.date.getDate()), // Disable all dates after 1 year
				customPredictor: function(date) {

					const dayOfWeek = weekdays[date.getDay()]

					if(close[dayOfWeek] === true) {

						return true

					}

				},
			}

			this.highlightedDate = {
				customPredictor: function(date) {

					const dayOfWeek = weekdays[date.getDay()]

					if(close[dayOfWeek] === true) {

						return false

					}

					if(promo[dayOfWeek].am != 0 || promo[dayOfWeek].pm != 0 || discovery[dayOfWeek].am != 0 || discovery[dayOfWeek].pm != 0) {

						return true

					}

				},
			}
			if(this.isPromo === '')
				this.customFormatter(this.date)
		},

		methods: {
			customFormatter(date) {

				const promo		= this.promo
				const discovery	= this.discovery
				const close		= this.close
				const dayOfWeek	= this.weekdays[date.getDay()]

				if(close[dayOfWeek] === true) {

					this.isPromo = this.isDiscovery = false

				} else {
					if(promo[dayOfWeek].am != 0 || promo[dayOfWeek].pm != 0 || discovery[dayOfWeek].am != 0 || discovery[dayOfWeek].pm != 0) {

						this.promonoon		= promo[dayOfWeek].am != 0 ? promo[dayOfWeek].am+'%' : ''
						this.promoeve		= promo[dayOfWeek].pm != 0 ? promo[dayOfWeek].pm+'%' : ''

						this.isPromo		= (this.promonoon != '' || this.promoeve != '') ? true : false

						this.discoverynoon	= discovery[dayOfWeek].am != 0 ? discovery[dayOfWeek].am+'%' : ''
						this.discoveryeve	= discovery[dayOfWeek].pm != 0 ? discovery[dayOfWeek].pm+'%' : ''

						this.isDiscovery	= (this.discoverynoon != '' || this.discoveryeve != '') ? true : false


					} else {

						this.isPromo = this.isDiscovery = false

					}
				}

				this.selectedDate	= moment(date).locale(this.lang).format('dddd DD MMMM YY')
				this.showDate		= moment(date).locale(this.lang).format('dddd D MMMM')

				return this.selectedDate

			},

			openCalendar() {

				this.$refs.restoDetailCalendar.showCalendar()

			},
		}

	}
</script>

<style></style>



// WEBPACK FOOTER //
// resources/assets/js/components/RestoDatePicker.vue